const setRem = () => {
  const scale = document.documentElement.clientWidth / 450;
  document.documentElement.style.fontSize = scale * 16 + "px";
};
setRem();
window,
  (onresize = function () {
    setRem();
  });
